export const visit = (vm, at) => {
at({ "fr": { "priceComponents": { "pricePerMonth": "{{price}}/mois", "pricePerMonthPerSeat": "{{price}}/mois/licence", "subtexts": { "startsAt": "\xC0 partir de" } } } });
};